import { type QueryClient } from '@tanstack/react-query';
import { type LoaderFunctionArgs, type RouteObject } from 'react-router-dom';

import { getTranslationLanguagesQuery } from '@/api/translation/getTranslationLanguages';

export const translationsRoute = (queryClient: QueryClient): RouteObject => ({
  path: 'translations',
  children: [
    {
      path: '',
      loader: async ({ params }: LoaderFunctionArgs) => {
        const { gameId, sandboxId } = params;
        if (!gameId || !sandboxId) {
          throw new Error('Game ID and sandbox ID are required');
        }
        return {
          locales: await queryClient.ensureQueryData(
            getTranslationLanguagesQuery(gameId, sandboxId),
          ),
        };
      },
      lazy: async () => await import('./translations'),
    },
  ],
});
